<template>
  <el-dialog
    class="dialog"
    title="CA在线检测"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="fun_HandleClose"
    @close="fun_HandleClose"
    width="60%"
    >
      <div class="caDetection">
        <Co-collapseForm
          ref="collapseForm" 
          :formConfigList="formConfigList" 
          :isBtn="false" 
          :span="24" 
          :enInform="form" 
          labelWidth="200px"
          @fun_GetSelectVal="fun_GetSelectVal"
          >
          <!-- CA证书品牌 -->
          <div slot="lockBrandName">
            <el-input v-model="form.lockBrandName" disabled></el-input>
            <el-button class="comBtn" @click="fun_CheckCAInfo"><img src="@/assets/images/loginIcon.png" alt="">检测</el-button>
          </div>
          <!-- 公章 -->
          <div class="img" slot="officialSealNo">
            <img :src="officialSealImg" alt="" style="width: 200px;"/>
          </div>
          <!-- 法人私章 -->
          <div class="img" slot="personChopNo">
            <img :src="personChopImg" alt="" style="width: 200px;"/>
          </div>
          <!-- 项目负责人签章 -->
          <div class="img" slot="signChopNo">
            <img :src="signImg" alt="" style="width: 200px;"/>
          </div>
        </Co-collapseForm>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogVisible = false">取 消</el-button>
      </span>
  </el-dialog>
</template>
<script>
import { fun_PostAction, fun_Download } from "@/api/index";
import {
  fun_CheckLockBrand,
  fun_CheckLockBrandName,
  fun_ECCAInit,
  fun_GetExpirationDate, fun_GetLockNumber,
  fun_IsIe,
  isIE
} from "../../utils/commonLock";
import "../../utils/security.js";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: false,
      key: null, // 加密key
      // 弹窗
      dialogVisible: false,
      activeTab: "1",// 切换选择
      // 表单配置
      formConfigList: [
        {
          title: "",
          name: "1",
          icon: "",
          formConfigList: [
            {
              label: "CA证书品牌：",
              value: "lockBrandName",
              type: "slot",
              slotName: "lockBrandName"
            },
            {
              label: "证书类型：",
              value: "caTypeName",
              type: "input",
              disabled: true,
            },
            {
              label: "证书所有者：",
              value: "caUser",
              type: "input",
              disabled: true,
            },
            {
              label: "证书到期日：",
              value: "expirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "时间戳到期日：",
              value: "timeStampExpirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "电子公章到期日：",
              value: "officialExpirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "法人私章到期日：",
              value: "privateExpirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "项目负责人签章到期日：",
              value: "registrantExpirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "证书序列号：",
              value: "serialNumber",
              type: "input",
              disabled: true,
            },
            {
              label: "锁类别：",
              value: "caCategory",
              type: "input",
              disabled: true,
            },
            {
              label: "公章：",
              type: "slot",
              slotName: "officialSealNo",
              class: "picItem"
            },
            {
              label: "法人私章：",
              type: "slot",
              slotName: "personChopNo",
              class: "picItem"
            },
            {
              label: "项目负责人签章：",
              type: "slot",
              slotName: "signChopNo",
              class: "picItem"
            },
          ]
        },
      ],
      // 表单字段
      qrForm: {
        certSn: null, // 锁编号
        loginUserType: null, // 扫码类型 01个人 02企业
        personName: null, // 扫码个人名称
        legalName: null, // 扫码企业名称
        lockType: null, // 扫码企业类型
        token: null, // 扫码token
        shield: null, // 盾id
        tid: null, // tid
        idCard: null, // 身份证
        idCardHash: null, // 身份证hash
        transactionCode: null, // 个人/单位交易编码
        signatureCertSn: null, // 锁编号
        personalName: null, // 扫码个人名称
      },
      // 表单字段
      form: {
        exponent: null, // 加密exponent参数
        modulus: null, // 加密modulus参数
        userName: null, // 用户名
        userPassword: null, // 用户密码
        userPlatformFlag: null, // 账号平台标识
        lockBrandName: null, // CA证书品牌
        caTypeName: null, // 证书类型
        caUser: null, // 证书所有者
        expirationDate: null, // 证书到期日
        timeStampExpirationDate: null, // 时间戳到期日
        officialExpirationDate: null, // 电子公章到期日
        privateExpirationDate: null, // 法人私章到期日
        registrantExpirationDate: null, // 项目负责人签章到期日
        serialNumber: null, // 证书序列号
        lockId: null, // 锁关联编号
        platformFlag: null, // 平台标识
        caCategory: null, // 锁类别
        officialSealNo: null, // 企业公章编号
        personChopNo: null, // 法人私章编号
        signChopNo: null, // 项目负责人签章编号
      },
      officialSealImg: require("@/assets/images/cms/noCheck.png"), // 企业公章图片
      personChopImg: require("@/assets/images/cms/noCheck.png"), // 法人私章图片
      signImg: require("@/assets/images/cms/noCheck.png"), // 项目负责人章图片
    };
  },
  created() {
  },
  props: {
  },
  methods: {
    /**
     * 获取参数接口
     * @author 滕威
     */
    fun_GetRSAKey() {
      // 调用获取加密参数接口
      fun_PostAction("/getRSAKey").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取exponent
          this.form.exponent = data.exponent;
          // 获取modulus
          this.form.modulus = data.modulus;
        }
      });
    },
    /**
     * 判断显示签章采集信息
     */
    fun_GetShowSign(val){
      // 重新设置表单
      this.formConfigList = [
        {
          title: "",
          name: "1",
          icon: "",
          formConfigList: [
            {
              label: "CA证书品牌：",
              value: "lockBrandName",
              type: "slot",
              slotName: "lockBrandName"
            },
            {
              label: "证书类型：",
              value: "caTypeName",
              type: "input",
              disabled: true,
            },
            {
              label: "证书所有者：",
              value: "caUser",
              type: "input",
              disabled: true,
            },
            {
              label: "证书到期日：",
              value: "expirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "时间戳到期日：",
              value: "timeStampExpirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "电子公章到期日：",
              value: "officialExpirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "法人私章到期日：",
              value: "privateExpirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "项目负责人签章到期日：",
              value: "registrantExpirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "证书序列号：",
              value: "serialNumber",
              type: "input",
              disabled: true,
            },
            {
              label: "锁类别：",
              value: "caCategory",
              type: "input",
              disabled: true,
            },
            {
              label: "公章：",
              type: "slot",
              slotName: "officialSealNo",
              class: "picItem"
            },
            {
              label: "法人私章：",
              type: "slot",
              slotName: "personChopNo",
              class: "picItem"
            },
            {
              label: "项目负责人签章：",
              type: "slot",
              slotName: "signChopNo",
              class: "picItem"
            },
          ]
        },
      ];
      // 声明需要过滤的数据
      var arr = [];
      // 判断是交易人证书
      if(val.caTypeName === "交易人数字证书"){
        // 过滤项目负责人签章
        this.formConfigList[0].formConfigList = this.formConfigList[0].formConfigList.filter(item => item.slotName !== "signChopNo");
      }
      // 如果是注册人员证书
      else if(val.caTypeName === "注册人员数字证书"){
        arr = ['officialSealNo', 'personChopNo'];
        // 过滤公章、法人私章
        this.formConfigList[0].formConfigList = this.formConfigList[0].formConfigList.filter(item => !arr.includes(item.slotName));
      }
      // 如果扫码类型不为空
      if(this.qrType != null && this.qrType != ''){
        arr = ['expirationDate', 'timeStampExpirationDate', 'caCategory'];
        // 过滤字段
        this.formConfigList[0].formConfigList = this.formConfigList[0].formConfigList.filter(item => !arr.includes(item.value));
      }
      // 如果不是交易人数字证书或者扫码类型不为空
      if((this.form.caTypeName != '交易人数字证书') || (this.qrType != null && this.qrType != '')){
        arr = ['officialExpirationDate', 'privateExpirationDate'];
        // 过滤字段
        this.formConfigList[0].formConfigList = this.formConfigList[0].formConfigList.filter(item => !arr.includes(item.value));
      }
      // 如果不是注册人员数字证书或者扫码类型不为空
      if((this.form.caTypeName != '注册人员数字证书') || (this.qrType != null && this.qrType != '')){
        arr = ['registrantExpirationDate'];
        // 过滤字段
        this.formConfigList[0].formConfigList = this.formConfigList[0].formConfigList.filter(item => !arr.includes(item.value));
        // 遍历
        this.formConfigList[0].formConfigList.map((e, index) => {
          // 如果锁类别
          if (e.value == "caCategory") {
            // 设置宽度
            e.width = "100%";
          }
        });
      }
    },
    /**
     * CA检测
     */
    fun_CheckCAInfo(){
      // 全局加载框
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
      // 清空参数
      this.fun_ClearValue();
      // 获取参数接口
      this.fun_GetRSAKey();
      // 初始化
      fun_IsIe();
      // 控件初始化
      if (!fun_ECCAInit()) {
        // 校验不通过，返回false，页面给出提示
        // 加载框取消
        this.fullLoading.close();
        return false
      }
      // CA自动检测
      let regLockBrand = fun_CheckLockBrand();
      // 确认CA驱动是否已打开
      if(!isIE){
        // 锁信息等于0
        if(regLockBrand == '0'){
          // 请求失败，弹出失败msg的消息提示
          this.$message.error("检测到您可能未打开驱动，请根据提示打开CA驱动，确认后重新提交！");
          // 加载框取消
          this.fullLoading.close();
          return;
        }
      }
      // 锁品牌为空
      if(regLockBrand == '' || regLockBrand == null){
        // 请求失败，弹出失败msg的消息提示
        this.$message.error("请检查是否插入CA锁或者是否安装CA驱动，请确认后重新提交！");
        // 加载框取消
        this.fullLoading.close();
        return;
      }
      // 设置CA证书品牌
      this.form.lockBrandName = fun_CheckLockBrandName(regLockBrand);
      // 证书到期日
      let expirationDate = fun_GetExpirationDate();
      // 获取硬件序列号
      let serialNumber = fun_GetLockNumber();
      // 设置公章图片读取中
      this.officialSealImg = require("@/assets/images/cms/readIn.png");
      // 设置法人私章图片读取中
      this.personChopImg = require("@/assets/images/cms/readIn.png");
      // 设置项目负责人签章图片读取中
      this.signImg = require("@/assets/images/cms/readIn.png");
      // 调用获取加密参数接口
      fun_PostAction("/cmsCaLockInfo/tenderHomeCheckCa/",{
        serialNumber: serialNumber, // 硬件序列号
        lockBrand: regLockBrand, // 锁品牌
        expirationDate: expirationDate, // 证书到期日
      }).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 判断请求是否成功
        if (result) {
          this.form.userPlatformFlag = data.userPlatformFlag; // 账号平台标识
          this.form.caTypeName = data.caTypeName; // 证书类型
          this.form.caUser = data.caUser; // 证书所有者
          this.form.expirationDate = data.expirationDate; // 证书到期日
          this.form.timeStampExpirationDate = data.timeStampExpirationDate; // 时间戳到期日
          this.form.officialExpirationDate = data.officialExpirationDate; // 电子公章到期日
          this.form.privateExpirationDate = data.privateExpirationDate; // 法人私章到期日
          this.form.registrantExpirationDate = data.registrantExpirationDate; // 项目负责人签章到期日
          this.form.serialNumber = data.serialNumber; // 证书序列号
          this.form.lockId = data.lockId; // 锁关联编号
          this.form.platformFlag = data.platformFlag; // 平台标识
          this.form.caCategory = data.caCategory; // 锁类别
          this.form.officialSealNo = data.officialSealNo; // 企业公章编号
          this.form.personChopNo = data.personChopNo; // 法人私章编号
          this.form.signChopNo = data.signChopNo; // 项目负责人签章编号
          // 执行显示隐藏签章信息
          this.fun_GetShowSign(data);
          // 如果是交易人数字证书
          if(this.form.caTypeName == "交易人数字证书"){
            // 设置企业公章
            this.fun_GetSignatureImage("officialSeal", this.form.officialSealNo);
            // 设置法人私章
            this.fun_GetSignatureImage("personChop", this.form.personChopNo);
          }
          // 如果是注册人员数字证书
          else if(this.form.caTypeName == "注册人员数字证书"){
            // 设置项目负责人签章
            this.fun_GetSignatureImage("sign", this.form.signChopNo);
          }
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
          // 设置公章图片清空
          this.officialSealImg = require("@/assets/images/cms/noCheck.png");
          // 设置法人私章图片清空
          this.personChopImg = require("@/assets/images/cms/noCheck.png");
          // 设置项目负责人签章图片清空
          this.signImg = require("@/assets/images/cms/noCheck.png");
        }
      });
      // 加载框取消
      this.fullLoading.close();
    },
    /**
     * 获取签章图片
     */
    fun_GetSignatureImage(e, i){
      // 签章编号不为空
      if(i != "" && i != null){
        // 获取加密key
        this.key = window.RSAUtils.getKeyPair(this.form.exponent,"", this.form.modulus);
        // 签章编号加密
        let signatureNo = window.RSAUtils.encryptedString(this.key, i);
        // 获取id
        fun_Download("/cmsCaLockInfo/getSignatureImage?signatureNo=" + signatureNo + "&rand=" + new Date().getTime()).then(res => {
          if (res) {
            // 存储this
            const _this = this;
            const data = new Blob([res.data]);
            this.fun_GetBlobToBase64(data).then(res => {
              // 企业公章
              if(e == "officialSeal"){
                // 设置公章图片
                _this.officialSealImg = res;
              }
              // 法人私章
              else if(e == "personChop"){
                // 设置法人私章图片
                _this.personChopImg = res;
              }
              // 项目负责人签章
              else if(e == "sign"){
                // 设置项目负责人签章图片
                _this.signImg = res;
              }
            });
          }
        });
      }else{
        // 企业公章
        if(e == "officialSeal"){
          // 设置公章图片
          this.officialSealImg = require("@/assets/images/cms/noBinding.png");
        }
        // 法人私章
        else if(e == "personChop"){
          // 设置法人私章图片
          this.personChopImg = require("@/assets/images/cms/noBinding.png");
        }
        // 项目负责人签章
        else if(e == "sign"){
          // 设置项目负责人签章图片
          this.signImg = require("@/assets/images/cms/noBinding.png");
        }
      }
    },
    // 清空参数
    fun_ClearValue(){
      // 遍历
      for(var i in this.form){
        // 清空表单
        this.form[i] = null;
      }
    },
    /**
     * 转为base64URL
     * @author 滕威
     */
    fun_GetBlobToBase64(blob) {
      return new Promise((resolve, reject) => {
        // 创建文件对象
        const reader = new FileReader();
        reader.onload = e => {
          resolve(e.target.result);
        };
        reader.readAsDataURL(blob);
        reader.onerror = () => {
          reject(new Error("文件流异常！"));
        };
      });
    },
    /**
     * 弹窗关闭前的回调
     */
    fun_HandleClose(){
      // 显示图片
      this.interconnection = true; // 中招
      this.dzyyzz = true; // 电子营业执照
      // 隐藏扫码
      this.interconnectionCode = false; // 中招
      this.dzyyzzCode = false; // 电子营业执照
      // 切换状态为1
      this.activeTab = "1";
      // 遍历
      for(var i in this.form){
        // 清空表单
        this.form[i] = null;
      }
      // 重新设置表单
      this.formConfigList = [
        {
          title: "",
          name: "1",
          icon: "",
          formConfigList: [
            {
              label: "CA证书品牌：",
              value: "lockBrandName",
              type: "slot",
              slotName: "lockBrandName"
            },
            {
              label: "证书类型：",
              value: "caTypeName",
              type: "input",
              disabled: true,
            },
            {
              label: "证书所有者：",
              value: "caUser",
              type: "input",
              disabled: true,
            },
            {
              label: "证书到期日：",
              value: "expirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "时间戳到期日：",
              value: "timeStampExpirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "电子公章到期日：",
              value: "officialExpirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "法人私章到期日：",
              value: "privateExpirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "项目负责人签章到期日：",
              value: "registrantExpirationDate",
              type: "input",
              disabled: true,
            },
            {
              label: "证书序列号：",
              value: "serialNumber",
              type: "input",
              disabled: true,
            },
            {
              label: "锁类别：",
              value: "caCategory",
              type: "input",
              disabled: true,
            },
            {
              label: "公章：",
              type: "slot",
              slotName: "officialSealNo",
              class: "picItem"
            },
            {
              label: "法人私章：",
              type: "slot",
              slotName: "personChopNo",
              class: "picItem"
            },
            {
              label: "项目负责人签章：",
              type: "slot",
              slotName: "signChopNo",
              class: "picItem"
            },
          ]
        },
      ];
      // 设置公章图片
      this.officialSealImg = require("@/assets/images/cms/noBinding.png");
      // 设置法人私章图片
      this.personChopImg = require("@/assets/images/cms/noBinding.png");
      // 设置项目负责人签章图片
      this.signImg = require("@/assets/images/cms/noBinding.png");
      // 关闭弹窗
      this.dialogVisible = false;
    },
    /**
     * 下拉框值改变事件
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
  }
};
</script>
<style lang="scss" scoped>
.dialog{
  /deep/.el-dialog{
    .el-dialog__body{
      padding: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .collapse-form{
        .el-form{
          .el-collapse{
            .el-collapse-item{
              .el-collapse-item__wrap{
                .el-collapse-item__content{
                  .el-row{
                    .el-col{
                      display: flex;
                      flex-direction: row;
                      flex-wrap: wrap;
                      box-sizing: border-box;
                      .el-form-item.picItem{
                        width: 30%;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .caDetection{
        flex: 1;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        .scanCodes{
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
          img{
            cursor: pointer;
          }
          .shareCode{
            flex-direction: column;
            .shareCodeShow{
              display: flex;
              align-items: center;
              margin: 0;
            }
            .codeImg{
              text-align: center;
            }
            .tip{
              margin: 0;
              text-align: center;
            }
          }
          .code{
            display: flex;
            justify-content: center;
            .interconnectionCode,.dzzzCodeCode{
              text-align: center;
              .tip{
                margin: 0 !important;
              }
            }
            .interconnectionShow{
              display: flex;
              align-items: center;
              margin-right: 100px;
            }
          }
          .dzzzCodeShow{
            display: flex;
            align-items: center;
          }
          .dzzzCodeCode{
            text-align: center;
          }
          .tip{
            display: flex;
            flex-direction: column;
            margin-left: 20px;
            span{
              &:nth-child(1){
                font-weight: bold;
                font-size: 14px;
                color: rgba(0,0,0,0.85);
              }
              &:nth-child(2){
                font-weight: 400;
                font-size: 12px;
                color: #999999 !important;
                line-height: 20px;
              }
              &:nth-child(3),&:nth-child(4){
                color: #999999 !important;
                font-size: 12px;
                display: flex;
                align-items: center;
                a{
                  font-weight: bold;
                  font-size: 12px;
                  color: #4063E9 !important;
                }
                i{
                  color: #666666;
                  background-color: #666666;
                  width: 2px;
                  height: 15px;
                  margin: 0 5px;
                  display: inline-block;
                }
              }
            }
            span.cu{
              font-weight: bold;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.85) !important;
              cursor: pointer;
              display: inline-block;
            }
          }
        }
      }
    }
  }
}

</style>
